import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import styled from 'styled-components';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';

const StyledDialogContent = styled(DialogContent)`
  font-family: ${fontFamily.book};
  color: ${colors.blueMonday};
`;

const StyledDialogTitle = styled(DialogTitle)`
  && {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: ${fontFamily.medium};
      color: ${colors.squid};
      font-size: ${fontSize.large};
    }
  }
`;

const StyledActions = styled(DialogActions)`
  justify-content: center;
`;

type OwnProps = {
  title?: string;
  actions?: React.ReactNode;
  width?: number;
  children?: React.ReactNode;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof SolvDialog.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'SolvDialog' implicitly has type 'any' because it ... Remove this comment to see the full error message
const SolvDialog = (props: Props) => {
  const { actions, children, title, width } = props;
  const getPaperProps = () => ({
    style: {
      width: '100%',
      maxWidth: `${width}px`,
    },
  });

  return (
    <Dialog {...props} PaperProps={getPaperProps()}>
      {title && <StyledDialogTitle>{title}</StyledDialogTitle>}

      <StyledDialogContent>{children}</StyledDialogContent>

      {actions && <StyledActions>{actions}</StyledActions>}
    </Dialog>
  );
};

SolvDialog.defaultProps = {
  width: 400,
};

export default SolvDialog;
